import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import { H1, H2, Tr, Td } from "commons";
import { getFullClientName } from "commons/src/helpers/FormattingHelpers";
import { format, FORMAT } from "commons/src/NuDateUtils";

import { FolioTable } from "./FolioTable";

const PORTFOLIO_SUMMARY = "Portfolio summary";
const ACCOUNT_SUMMARY = "Account summary";

function PDFFrontPageComponent({
    accountNum = "Combined",
    adviser,
    user,
    logo,
    reportDate = Date.now()
}) {
    const isCombined = accountNum === "Combined";
    const title = isCombined ? PORTFOLIO_SUMMARY : ACCOUNT_SUMMARY;

    return (
        <Container data-testid="front-page-container">
            <ImageContainer>
                <Logo src={logo} />
            </ImageContainer>
            <Content>
                <H1 data-testid="front-page-title">{title}</H1>
                <H2 margin="0 0 1rem 0" data-testid="front-page-client-name">
                    {getFullClientName(user)}
                </H2>
                <Table>
                    <tbody>
                        <Tr data-testid="front-page-summary-table-row">
                            <Td align="left">Client reference</Td>
                            <Td align="right">{user.clientId}</Td>
                        </Tr>
                        {!isCombined && (
                            <Tr data-testid="front-page-summary-table-row">
                                <Td align="left">Account number</Td>
                                <Td align="right">{accountNum}</Td>
                            </Tr>
                        )}
                        <Tr data-testid="front-page-summary-table-row">
                            <Td align="left">Adviser</Td>
                            <Td align="right">{`${getFullClientName(adviser)} - ${
                                adviser.adviserOutletId
                            }`}</Td>
                        </Tr>
                        <Tr data-testid="front-page-summary-table-row">
                            <Td align="left">Report date</Td>
                            <Td align="right">{format(reportDate, FORMAT.SLASH_SEPARATED)}</Td>
                        </Tr>
                    </tbody>
                </Table>
            </Content>
        </Container>
    );
}

const Table = styled(FolioTable)`
    width: 40%;
    margin: 1rem 0 0 0;

    td {
        font-size: 1.2rem;
    }
`;

const Container = styled.section`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;

    @media not print {
        display: none;
    }
`;

const ImageContainer = styled.div`
    padding: 2rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

const Logo = styled.img`
    max-width: 250px;
    max-height: 250px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2rem;
    flex: 1;
    justify-content: center;
    align-items: flex-start;
`;

PDFFrontPageComponent.propTypes = {
    accountNum: PropTypes.string,
    adviser: PropTypes.object,
    user: PropTypes.object,
    logo: PropTypes.string,
    reportDate: PropTypes.object
};

const mapStateToProps = state => ({
    adviser: state.adviser.adviser,
    user: state.user.currentUser,
    logo: state.theme.selectedTheme.logo
});

export const PDFFrontPage = connect(mapStateToProps)(PDFFrontPageComponent);
